import React from "react";
import {
  PageContainer,
  PageTopbar,
  PageHeader,
  ContentContainer,
  type BreadcrumbItem,
  astryx,
  neutralTheme,
  useDocumentTheme,
} from "@shadowcue/ui";
import type { IUser } from "../../types/iuser";

interface ReportsProps {
  currentUser: IUser;
}

const breadcrumbs: BreadcrumbItem[] = [
  { label: "Dashboard", href: "/dashboard" },
  { label: "Reports", href: "/dashboard/reports" },
];

/**
 * Placeholder for the reports section. Not in the nav rail yet, so it is
 * reachable only by URL; it carries the same page chrome as every other
 * dashboard screen so it doesn't need styling of its own.
 */
const Reports = (_props: ReportsProps) => {
  const mode = useDocumentTheme();

  return (
    <astryx.Theme theme={neutralTheme} mode={mode}>
      <PageContainer>
        <PageTopbar breadcrumbs={breadcrumbs} />

        <ContentContainer loading={false}>
          <PageHeader
            title="Reports"
            description="The future home of all of your reports."
          />

          <astryx.Text type="body" color="secondary">
            Nothing to show yet.{" "}
            <astryx.Link href="/dashboard">Back to your dashboard</astryx.Link>
          </astryx.Text>
        </ContentContainer>
      </PageContainer>
    </astryx.Theme>
  );
};

export default Reports;
